import React from 'react';
import '../styles/CreateAccount.css';

const CreateAccount = ({ onBackToLogin }) => {
  return (
    <div className="create-account-section">
      <h2 className="create-account-title">Create account</h2>
      <form className="create-account-form">
        <div className="form-group">
          <input 
            type="text" 
            placeholder="First name" 
            className="form-input"
          />
        </div>
        <div className="form-group">
          <input 
            type="text" 
            placeholder="Last name" 
            className="form-input"
          />
        </div>
        <div className="form-group">
          <input 
            type="email" 
            placeholder="Email" 
            className="form-input"
          />
        </div>
        <div className="form-group">
          <input 
            type="password" 
            placeholder="Password" 
            className="form-input"
          />
        </div>
        <button type="submit" className="create-btn">
          Create
        </button>
        <button 
          type="button" 
          className="back-to-login" 
          onClick={onBackToLogin}
        >
          Back to Login
        </button>
      </form>
    </div>
  );
};

export default CreateAccount; 